import { Multiselect } from "multiselect-react-dropdown";
import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import {
  Button,
  Nav,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import swal from "sweetalert";
// import { ExcelRenderer } from "react-excel-renderer";
export default function Geofence() {
  const [searchData, setSearchData] = useState([]);
  const history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [forSearch, setForSearch] = useState([]);
  const [forSearchUpload, setForSearchUpload] = useState([]);
  const [pincode, setPincodes] = useState([]);
  const [allPin, setAllPin] = useState([]);
  const [uploadData, setUploadData] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [show4, setShow4] = useState(false);
  const [catDel, setCatDel] = useState(false);
  const [cat, setCat] = useState(false);
  const [show1, setShow1] = useState(false);
  const [name, setName] = useState("");
  const [geoData, setGeoData] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [vehicleData, setVehicleData] = useState([]);
  const [servicePincode, setServicePincode] = useState("");
  const [updateService, setUpdateService] = useState(false);
  const [addExist, setAddExist] = useState(false);
  const [addExistId, setAddExistId] = useState("");
 // const [catList, setCatList] = useState([]);
  var nameObject = [
    { name: "Auto" },
    { name: "Bike" },
    { name: "3 Wheeler" },
    { name: "Tata Ace" },
    { name: "PickUp 8ft" },
    { name: "Tata 407" },
    { name: "SUV/MUV" },
    { name: "Sedan" },
    { name: "Hatch Back" },
  ];
  const selection2 = (selectedValues) => {
    let vig = [];
    selectedValues.map((val) => {
      vig.push(val.name);
    });
    setVehicleData(vig);
  };
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const handleClose2 = () => {
    setShow1(false);
  };
  // function getCategory() {
  //   let cat = [];
  //   axios
  //     .get(Baseurl.baseurl + `/go-ui/get-category`)
  //     .then((res) => {
  //       res.data.categories.map((val) => {
  //         cat.push({ category: val.Category, title: val.Category });
  //       });
  //       cat.push({ category: "others", title: "Others" });
  //       setCatList(cat);
  //     })
  //     .catch((err) => {
  //       if (err.toString() === "Error: Network Error") {
  //         history.push("/offline");
  //       } else {
  //         history.push("/400");
  //       }
  //     });
  // }
  function getData() {
    axios
      .get(Baseurl.baseurl + `/go-geofence/get-all-geofence`)
      .then((res) => {
        setSpinner(false);
        setGeoData(res.data.pincodes);
        setSearchData(res.data.pincodes);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  useEffect(() => {
    getData();
   // getCategory();
  }, []);

  function removeDuplicates(arr) {
    var counts = arr.reduce(function (counts, item) {
      counts[item] = (counts[item] || 0) + 1;
      return counts;
    }, {});
    return Object.keys(counts).reduce(function (arr, item) {
      if (counts[item] === 1) {
        arr.push(item);
      }
      if (counts[item] === 3) {
        arr.push(item);
      }
      return arr;
    }, []);
  }
  function deleteGeofence() {
    axios
      .delete(
        Baseurl.baseurl + `/go-geofence/delete-geofence-by-id/${serviceId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow4(false);
  }
  function updateCategory() {
    var serviceData = {
      vehicle: vehicleData,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-geofence/add-new-vehicle-geofence/${serviceId}`,
        serviceData
      )
      .then((response) => {
        if (response.data.status) {
          swal("Category Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getData();
        handleClose2();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function handleShow1(id, area) {
    setServiceId(id);
    setUpdateService(true);
    setShow1(true);
    //setServiceName(name);
    // setVehicleData(area);
  }
  function handleShow2(pincode) {
    setServicePincode(pincode);
    setForSearch(pincode);
    setShow1(true);
    setUpdateService(false);
  }
  function onChangeFile(file) {
    // ExcelRenderer(file, (err, resp) => {
    //   if (err) {
    //   } else {
    //     let newRows = [];
    //     let allpin = [];
    //     resp.rows.slice(0).map((row, index) => {
    //       if (row && row != "undefined" && row != "") {
    //         allpin.push(row[1]);
    //         newRows.push({
    //           key: index,
    //           location: row[0],
    //           pincode: row[1],
    //           state: row[2],
    //           district: row[3],
    //         });
    //       }
    //     });
    //     setAllPin(allpin);
    //     setUploadData(newRows);
    //     setForSearchUpload(newRows);
    //   }
    // });
  }
  function pincodeSelect(pin) {
    setPincodes((oldArray) => oldArray.concat(pin));
  }
  function addGeofence(val) {
    if (addExist) {
      if (val == "addAll") {
        var Pincodes = {
          pincode: allPin,
        };
      } else {
        var Pincodes = {
          pincode: [...new Set(removeDuplicates(pincode))],
        };
      }
      axios
        .put(
          Baseurl.baseurl +
            `/go-geofence/add-new-pincode-geofence/${addExistId}`,
          Pincodes
        )
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("Updated", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            setPincodes([]);
            setUploadData("");
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
          setShow(false);
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      if (val == "addAll") {
        var Pincodes = {
          pinCode: allPin,
          locationName: `${name}`,
          vehicleTypes: vehicleData,
        };
      } else {
        var Pincodes = {
          pinCode: [...new Set(removeDuplicates(pincode))],
          locationName: `${name}`,
          vehicleTypes: vehicleData,
        };
      }
      axios
        .post(Baseurl.baseurl + `/go-geofence/add-geofence`, Pincodes)
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("Added", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            setPincodes([]);
            setUploadData("");
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
          setShow(false);
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    }
  }
  function deletePinGeo() {
    var serviceData = {
      pincode: [...new Set(removeDuplicates(pincode))],
    };
    axios
      .put(
        Baseurl.baseurl + `/go-geofence/delete-pincode-geofence/${serviceId}`,
        serviceData
      )
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setPincodes([]);
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getData();
        handleClose2();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function deleteCategory() {
    var categoryData = {
      vehicleData: cat,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-geofence/remove-vehicle-geofence/${serviceId}`,
        categoryData
      )
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow4(false);
        getData();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function searchPincode(value) {
    let filteredData = [];
    forSearch.map((val) => {
      let pinString = val.toString();
      if (pinString.includes(value)) {
        filteredData.push(val);
      }
    });
    setServicePincode(filteredData);
  }
  function searchUpload(value) {
    let filteredData = [];
    forSearchUpload.map((val) => {
      let pinString = val.pincode.toString();
      if (
        val.location.toLowerCase().includes(value) ||
        pinString.includes(value)
      ) {
        filteredData.push(val);
      }
    });
    setUploadData(filteredData);
  }
  function searchGeofence(value) {
    let filteredData = [];
    if (searchData) {
      searchData.map((val) => {
        if (val.Name.toLowerCase().includes(value)) {
          filteredData.push(val);
        }
      });

      setGeoData(filteredData);
    }
  }
  return (
    <div className="row">
      <div className="col-xl-12 col-lg-12">
        <div
          className="card"
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <div className="card-header">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search here..."
                onChange={(e) => {
                  searchGeofence(e.target.value);
                }}
              />
            </div>
            <button
              onClick={() => {
                setShow(true);
                setAddExist(false);
                setUploadData("");
              }}
              className="btn btn-primary"
            >
              Create Geofence
            </button>
          </div>
          <Modal
            show={show4}
            onHide={() => {
              setShow4(false);
            }}
          >
            <Modal.Body>
              {catDel ? (
                <h4>
                  Are you sure !! you want to delete{" "}
                  <text className="text-danger ml-1">{cat}</text>{" "}
                </h4>
              ) : (
                <h4>
                  Are you sure !! you want to delete{" "}
                  <text className="text-danger ml-1">{serviceName}</text>{" "}
                </h4>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => {
                  if (catDel) {
                    deleteCategory();
                  } else {
                    deleteGeofence();
                  }
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            size="lg"
            show={show}
            onHide={() => {
              setShow(false);
            }}
          >
            <Modal.Body>
              <div className="form-group row">
                {!addExist && (
                  <>
                    <div className="col-sm-4">
                      <label>
                        <strong>Category</strong>
                      </label>
                      <Multiselect
                        closeIcon="close"
                        options={nameObject}
                        displayValue="name"
                        onSelect={selection2}
                      />
                    </div>
                    <div className="col-sm-4 ">
                      <label>
                        {" "}
                        <strong>Name</strong>
                      </label>
                      <input
                        value={name}
                        type="text"
                        className="form-control"
                        placeholder="Area Name"
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                  </>
                )}
                <div className="col-sm-4">
                  <label>
                    <strong>Choose file to upload</strong>
                  </label>

                  <input
                    className="mt-2"
                    id="profilePic"
                    type="file"
                    onChange={(e) => {
                      onChangeFile(e.target.files[0]);
                    }}
                  />
                </div>
              </div>
              {uploadData && (
                <div
                  className="card mb-0"
                  style={{
                    color: "white",
                    background:
                      "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
                  }}
                >
                  <div className="card-header">
                    <input
                      type="text"
                      className="form-control col-sm-4 float-right"
                      placeholder="Search here..."
                      onChange={(e) => {
                        searchUpload(e.target.value);
                      }}
                    />
                    <Button
                      variant="primary"
                      
                      onClick={() => {
                        addGeofence("addAll");
                      }}
                    >
                      ADD ALL
                    </Button>
                  </div>
                  <div className="card-body">
                    <table className="dataTable">
                      <thead>
                        <tr>
                          <th></th>
                          <th>
                            <strong className="text-white">Location</strong>
                          </th>
                          <th>
                            <strong className="text-white">Pincodes</strong>
                          </th>
                          <th>
                            <strong className="text-white">State</strong>
                          </th>
                          <th>
                            <strong className="text-white">Disticts</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {uploadData.map((val) => {
                          return (
                            <tr>
                              <td>
                                <input
                                  type="checkbox"
                                  onClick={() => pincodeSelect(val.pincode)}
                                  className="mb-3"
                                  id="checkAll"
                                  required
                                />
                              </td>
                              <td>{val.location}</td>
                              <td>{val.pincode}</td>
                              <td>{val.state}</td>
                              <td>{val.district}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              {uploadData && (
                <Button
                  className="float-left"
                  variant="primary "
                  onClick={() => {
                    addGeofence("add");
                  }}
                >
                  ADD
                </Button>
              )}
            </Modal.Footer>
          </Modal>

          <Modal
            size={updateService ? "" : "lg"}
            show={show1}
            onHide={handleClose2}
          >
            <Modal.Body>
              <div className="card-body">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-sm-12">
                      {updateService ? (
                        <div className="form-group row">
                          <div className="col-sm-8" id="multiselect">
                            <label>Category</label>
                            <Multiselect
                              closeIcon="close"
                              options={nameObject}
                              displayValue="name"
                              onSelect={selection2}
                            />
                          </div>
                          <div className="mt-1">
                            <Link>
                              <button
                                onClick={() => {
                                  updateCategory();
                                }}
                                className="btn btn-primary ml-4 mt-3"
                              >
                                Update
                              </button>
                            </Link>
                          </div>
                        </div>
                      ) : (
                        <>
                          <input
                            type="number"
                            className="form-control col-sm-4 float-right"
                            placeholder="Search here..."
                            onChange={(e) => {
                              searchPincode(e.target.value);
                            }}
                          />
                          <Table responsive className="table table-striped">
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  <strong>Pincodes</strong>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {servicePincode &&
                                servicePincode.map((i) => (
                                  <tr>
                                    <td>
                                      <input
                                        type="checkbox"
                                        onClick={() => pincodeSelect(i)}
                                        className="mb-3"
                                        id="checkAll"
                                        required
                                      />
                                    </td>
                                    <td>{i}</td>
                                  </tr>
                                ))}
                            </tbody>
                            <button
                              onClick={() => {
                                deletePinGeo();
                              }}
                              className="btn btn-primary mt-3"
                            >
                              Delete
                            </button>
                          </Table>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <div className="card-body">
            <div className="col-sm-12">
              <div id="job_data" className="dataTables_wrapper ">
                {spinner ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <Table responsive className="table text-white">
                    <thead>
                      <tr>
                        <th>
                          <strong>Slno.</strong>
                        </th>
                        <th>
                          <strong>NAME</strong>
                        </th>
                        <th>
                          <strong>Vehicle Types</strong>
                        </th>
                        <th>
                          <strong>Update Pincode</strong>
                        </th>
                        <th>
                          <strong>Actions</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {geoData &&
                        geoData.map((i, key) => (
                          <tr>
                            <td>{key + 1}</td>
                            <td>{i.Name}</td>
                            <td>
                              {i.VehicleTypes.map((val) => {
                                return (
                                  <div>
                                    <label className="col-sm-8">{val}</label>
                                    <Link
                                      onClick={() => {
                                        setShow4(true);
                                        setCatDel(true);
                                        setCat(val);
                                        setServiceId(i._id);
                                      }}
                                      href="#"
                                      className="btn btn-danger shadow btn-xs sharp"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </Link>
                                  </div>
                                );
                              })}
                            </td>
                            <td>
                              {" "}
                              <Link
                                onClick={() => {
                                  setShow(true);
                                  setAddExistId(i._id);
                                  setAddExist(true);
                                  setUploadData("");
                                }}
                                href="#"
                                className="btn btn-secondary shadow btn-xs sharp ml-5"
                              >
                                <i className="fa fa-plus-square"></i>
                              </Link>
                            </td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="warning"
                                  className="light sharp i-false"
                                >
                                  {svg1}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      handleShow1(i._id, i.Category);
                                    }}
                                  >
                                    Update Vehicle
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setCatDel(false);
                                      setShow4(true);
                                      setServiceId(i._id);
                                      setServiceName(i.Name);
                                    }}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      handleShow2(i.PinCode);
                                      setServiceId(i._id);
                                    }}
                                  >
                                    View Geofence
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            {/* <td>{i.Name }</td> */}
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                )}

                {!geoData && (
                  <Alert
                    variant="success"
                    className="alert-dismissible fade show text-center"
                  >
                    Add Serviceable Area
                  </Alert>
                )}
                <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                  <div className="dataTables_info text-white">
                    Showing {activePag.current * sort + 1} to{" "}
                    {data.length > (activePag.current + 1) * sort
                      ? (activePag.current + 1) * sort
                      : data.length}{" "}
                    of {data.length} entries
                  </div>
                  <div
                    className="dataTables_paginate paging_simple_numbers"
                    id="example5_paginate"
                  >
                    <Link
                      className="paginate_button previous disabled"
                      onClick={() =>
                        activePag.current > 0 && onClick(activePag.current - 1)
                      }
                    >
                      Previous
                    </Link>
                    <span>
                      {paggination.map((number, i) => (
                        <Link
                          key={i}
                          className={`paginate_button  ${
                            activePag.current === i ? "current" : ""
                          } `}
                          onClick={() => onClick(i)}
                        >
                          {number}
                        </Link>
                      ))}
                    </span>
                    <Link
                      className="paginate_button next"
                      onClick={() => {
                        activePag.current + 1 < paggination.length &&
                          onClick(activePag.current + 1);
                      }}
                    >
                      Next
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
